import { useSelector } from 'react-redux';

export const useSafeSelector = (selector) => {
  try {
    return useSelector(selector);
  } catch (error) {
    // Fall back to undefined if the selector throws an error in case of non redux app like assessment or signup
    return undefined;
  }
};
